import { Pipe, PipeTransform } from '@angular/core';
import { Order } from '../../models';
import { EOD_COMPLETED } from '../../../ngrx/status-types';

/**
 * Active Order pipe
 * Takes an order as an argument and filters out inactive orders
 * e.g. Orders with a status of "EOD Complete"
 *
 * Usage: orders | activeOrder
 */

@Pipe({
  name: 'activeOrder'
})
export class ActiveOrderPipe implements PipeTransform {
  transform(orders: Order[]) {
    return orders.filter(order => order.status !== EOD_COMPLETED);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/active-order.pipe.ts